import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import {connect, useSelector} from "react-redux";
import {api} from "@redux/api";
import {
    FunctionalTestingColumns,
    functiontestingProps
} from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingColumns";
import {
    FunctionalTestingFormFields
} from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingFormFields";
import FunctionTestingEditableTable
    from "@containers/facility/Equipment/FunctionalTesting/FunctionTestingEditableTable";
import { withRouter } from "@/router/withRouter";
import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';
import Select from "@components/ResponsiveSelect";
import { FORM_TYPE_OPTIONS } from "@/constants/form-type-options";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";
import { debounce } from "lodash";
import moment from "moment";
import "./FunctionalTesting.css";

const FUNCTIONAL_TESTING_MOBILE_EXCLUDE_KEYS = [
    "equipment__name",
    "name",
    "functional_form__form_type",
    "created_date",
];

const FUNCTIONAL_TESTING_MOBILE_INCLUDE_KEYS = [
    "functional_form_name",
    "record_date",
    "record_by",
    "description",
    "createdby_name",
];

const formTypeLabel = (key) => {
    const map = {
        functional_test: "Functional Test",
        pm_checklist: "PM Checklist",
        generic: "Generic",
    };
    return key != null && map[key] != null ? map[key] : (key || "-");
};

const formatMobileDate = (value) => {
    if (value == null || value === "") return "-";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "-";
};

const renderFunctionalTestingMobileHeader = (record, navigateToFunctionalTestingDetail) => {
    const equipment = record.equipment__name;
    const name = record.name;
    const type = formTypeLabel(record.functional_form__form_type ?? record.functional_form_type);
    const createDate = formatMobileDate(record.created_date);

    const handleTitleClick = (event) => {
        event.stopPropagation();
        navigateToFunctionalTestingDetail(record.id);
    };

    return (
        <div className="functional-testing-mobile-card">
            <div className="functional-testing-mobile-card-main">
                <span className="functional-testing-mobile-card-equipment" title={equipment || ""}>
                    {equipment || "-"}
                </span>
                <span
                    className="functional-testing-mobile-card-title functional-testing-mobile-card-title-link"
                    title={name || ""}
                    onClick={handleTitleClick}
                >
                    {name || "-"}
                </span>
                <span className="functional-testing-mobile-card-date">{createDate}</span>
            </div>
            <div className="functional-testing-mobile-card-summary">
                <span className="functional-testing-mobile-card-meta">
                    <span className="functional-testing-mobile-card-meta-label">Form type: </span>
                    <span className="functional-testing-mobile-card-meta-value">{type}</span>
                </span>
            </div>
        </div>
    );
};

class FunctionalTesting extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            data: [],
            name: '',
            isLoading: false,
            query: null,
            tableRef: null,
            selectedTypeOption: null,
            selectedTemplateType: null,
            formTypeFilter: null,
            equipmentId: null,
            equipmentOptions: [],
            equipmentLookupLoading: false,
            filterValues: null,
            filterResetKey: 0,
        }
        this.debouncedLoadEquipmentOptions = debounce(this.loadEquipmentOptions, 250);
    }

    handleCreateFunctionalTesting = (body) => {
        console.log('create')
        const equipment_id = this.props.selectedRecord?.id?this.props.selectedRecord?.id:body.equipment__id;
        body['equipment'] = equipment_id;
        return api.createFunctionalTestingView(body).then(
            response => {
                // console.log('create', response);
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteFunctionalTesting = (id) => {
        return api.deleteFunctionalTestingView(id).then(
            response => {
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkDelete = (body) => {
        return api.bulkFunctionalTestingView(body).then(
            response => {
                this.refresh(false)
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        row['equipment'] = this.props.selectedRecord?.id?this.props.selectedRecord?.id:row.equipment__id;

        return api.editFunctionalTestingView(key, row).then(
            response => {
                this.refresh(false)
                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {

        this.setState({
            isLoading: true,
        });
        console.log('FunctionalTesting::', this.props.selectedRecord)
        let query_new = query +
            (this.props.selectedRecord?.id ? ('&equipment_id=' + (this.props.selectedRecord?.id)) : '') +
            (!this.props.selectedRecord?.id && this.state.equipmentId ? ('&equipmentId=' + (this.state.equipmentId)) : '') +
            (this.state.formTypeFilter
                ? (`&form_type=${encodeURIComponent(this.state.formTypeFilter)}`)
                : '')

        return api.filterFunctionalTestingView(query_new).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    total: response.data.count,
                    success: true,
                }
            }
        ).catch(error => (
            error
        ));
    }




    getFunctionalTesting = (data) => {

        this.setState({
            isLoading: false,
            data
        })

    }

    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    handleSearchSelect = (e, record) => {
        let data = record.record;
        this.setState({
            selectedTypeOption: data?.fields,
            selectedTemplateType: data
        })
    }

    handleFormTypeFilterChange = (value) => {
        this.setState({
            formTypeFilter: value || null,
            filterValues: {
                ...this.state.filterValues,
                form_type: value || null,
            },
        }, () => {
            this.refresh(false);
        });
    };

    loadEquipmentOptions = (keyword = "") => {
        this.setState({ equipmentLookupLoading: true });
        return api
            .lookupEquipments(encodeURIComponent(keyword || ""))
            .then((response) => {
                const equipmentOptions = (response.data || []).map((equipment) => ({
                    value: equipment.id,
                    label: equipment.name,
                }));
                this.setState({
                    equipmentOptions,
                    equipmentLookupLoading: false,
                });
                return equipmentOptions;
            })
            .catch((error) => {
                this.setState({ equipmentLookupLoading: false });
                return error;
            });
    };

    handleEquipmentFilterChange = (equipmentId) => {
        this.setState({
            equipmentId: equipmentId || null,
            filterValues: {
                ...this.state.filterValues,
                equipmentId: equipmentId || null,
            },
        }, () => {
            this.refresh(false);
        });
    };

    setFilters = (filterValues) => {
        this.setState({
            filterValues,
        });
    };

    resetFilters = () => {
        this.setState(
            {
                name: '',
                name_keyword: '',
                formTypeFilter: null,
                equipmentId: null,
                filterValues: null,
                filterResetKey: this.state.filterResetKey + 1,
            },
            () => {
                this.refresh(false);
            }
        );
    };

    renderFilter = () => {
        return (
            <div className="table-page-header-filter-row">
                <Select
                    key={`form-type-${this.state.filterResetKey}`}
                    name="form_type"
                    style={{ width: "12.5rem" }}
                    placeholder="Form type"
                    allowClear
                    value={this.state.formTypeFilter ?? undefined}
                    onChange={this.handleFormTypeFilterChange}
                    options={FORM_TYPE_OPTIONS}
                    optionFilterProp="label"
                />
                {!this.props.selectedRecord?.id ? (
                <Select
                    key={`equipment-${this.state.filterResetKey}`}
                    name="equipmentId"
                    style={{ width: "20rem" }}
                    placeholder="Equipment"
                    allowClear
                    showSearch
                    filterOption={false}
                    options={this.state.equipmentOptions}
                    loading={this.state.equipmentLookupLoading}
                    value={this.state.equipmentId ?? undefined}
                    onFocus={() => this.loadEquipmentOptions("")}
                    onSearch={(keyword) => this.debouncedLoadEquipmentOptions(keyword)}
                    onChange={this.handleEquipmentFilterChange}
                />
                ) : null}
            </div>
        );
    };
    gettableRef = (tableRef) => {
        console.log('tableRef', tableRef)
        this.setState({
            tableRef
        })
    }

    onNew = () => {
        this.props.navigate(this.props.createFunctionalTestingPath);
    };

    render() {

        return (

            <div>
                <FunctionTestingEditableTable
                    ref={this.tableRef}
                    columns={FunctionalTestingColumns()}
                    data={this.state.data}
                    columnProps={functiontestingProps}

                    getRecord={this.getFunctionalTesting}
                    createRecords={this.handleCreateFunctionalTesting}
                    deleteRecord={this.handleDeleteFunctionalTesting}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    postComment={this.handlePostComment}
                    renderFilter={this.renderFilter}
                    hide_search={false}
                    isRowClickable={false}
                    isRelated={false}
                    isAttachments={false}
                    setFilters={this.setFilters}
                    resetFilters={this.resetFilters}
                    filterValues={this.state.filterValues}
                    filterDescription={this.state.filterDescription}
                    getFormRef={this.gettableRef}
                    hide_imports={true}
                    formClassName={'flex-form grid grid-cols-4 '}
                    selectedRecord={this.props.selectedRecord}
                    new_text={'Create Form'}
                    onNew={this.onNew}
                    hid_new={!this.props.canWrite}
                    hideMobileTableExpand={true}
                    mobileCardHeaderRender={(record) => renderFunctionalTestingMobileHeader(record, this.props.navigateToFunctionalTestingDetail)}
                    mobileExpandedExcludeKeys={FUNCTIONAL_TESTING_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={FUNCTIONAL_TESTING_MOBILE_INCLUDE_KEYS}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {}
}
const mapDispatchToProps = dispatch => {
    return {

    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const canWrite = useAuth('functiontesting', AUTH_LEVEL.WRITE);
        const facilityContext = useSelector((state) => getFacilityContext(state));
        const createFunctionalTestingPath = buildFacilityPath('create-functional-testing', facilityContext) || '/switch-view';
        const { navigateToFunctionalTestingDetail } = useSmartNavigate();
        return (
            <Component
                {...props}
                canWrite={canWrite}
                createFunctionalTestingPath={createFunctionalTestingPath}
                navigateToFunctionalTestingDetail={navigateToFunctionalTestingDetail}
            />
        );
    }
    return NewComponent;
}

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FunctionalTesting)));
